export const BLANK_IMAGE = './assets/img/websites/image-blank.svg';
export const BLANK_VIDEO = './assets/img/websites/video-blank.svg';
export const BLANK_LOGO = './assets/img/websites/lpc-logo-example.svg';
export const BLANK_TESTIMONIAL_AVATAR = './assets/img/websites/lpc-avatar-example.svg';
export const BLANK_MAP_IMAGE = './assets/img/websites/map-image-blank.png';
